<template lang="pug">
#app
    .nav(v-show='!["errorPage","home"].includes($route.name)') 
        .logo-wrapper
            img.logo(src='@/assets/imgs/logo.png', @click='$router.push("/")')
            img.logo(src='@/assets/imgs/logo2.png', @click='$router.push("/")')
        .right
            img.search(
                src='@/assets/imgs/菜单栏搜索@3x.png',
                @click='$router.push({ name: "search" })'
            )
            img.menu(
                src='@/assets/imgs/菜单栏按钮@3x.png',
                @click='showMenu = true'
            )
    van-popup(v-model='showMenu', position='top')
        van-cell(
            :title='item.title',
            is-link,
            v-for='item in menu',
            @click='goRoute(item)'
        )
    ContactFloatButton(v-show='!$route.meta.hideContactButton')
    transition(name='van-fade', mode='out-in')
        keep-alive(:include='/home|search/')
            router-view.sr
</template>

<script>
import { setStorage } from '@/utils/localstorage'
import { ACCESS_KEY, HISTORY_KEY } from '@/configs/constants'
import { mapActions } from 'vuex'
import ContactFloatButton from '@/views/components/ContactFloatButton'
import { path } from 'animejs'
import { setBaseInfo, initJsConfig, concatWithSymbol } from '@custouch/proxy-use'
import { ONLY_PID_STR } from '@/configs/constants'
import { initSet } from '@/configs/common'
export default {
    name: 'app',
    data() {
        return {
            hasInited: false,
            showMenu: false,
            menu: [
                { title: '首页', to: { name: 'home' } },
                { title: '产品中心', to: { name: 'productTech' } },
                { title: '精选资料', to: { name: 'documentCatalog' } },
                { title: '互动专区', to: { name: 'interaction' } },
                { title: '会员中心', to: { name: 'myFollow' } },
                { title: '我的咨询', to: { name: 'customerService' }, link: window.env.VUE_APP_CONTACT_URL },
            ]
        }
    },
    computed: {
        cmsStr(){
            const { DATA } = window.env
            const { poolId } = DATA
            const { params, query, meta } = this.$route
            const cmsGroup = [
                poolId,
                params.mId || query.mId || meta.mId,
                query.pId || params.hId || query.hId || meta.hId,
                params.rId || query.rId
            ]
            const cmsJ = cmsGroup.join(',')
            return ONLY_PID_STR === cmsJ ? undefined : cmsJ
        },
        pageInfo() {
            const { name, productBu } = this.$route.query
            const { type, section } = this.$route.params
            const title = this.concatTrackInfo(this.$route.meta.title, section, type, this.$route.params.name, name)
            const { LOGO } = window.env
            return {
                title,
                cms: this.cmsStr,
                productBu,
                shareInfo: {
                    title: document.title,
                    desc: '点击查看详情',
                    imgUrl: LOGO
                }
            }
        }
    },
    components: {
        ContactFloatButton
    },
    methods: {
        ...mapActions(['setInfo']),
        // 以‘-’拼接，传入string[]
        concatTrackInfo(...arr) {
            let res = '', lastChar = ''
            arr.forEach(t => {
                if (t) {
                    lastChar = res.charAt(res.length - 1)
                    if (lastChar && lastChar != '-') {
                        res += '-' + t
                    } else {
                        res += t
                    }
                }
            })
            return res
        },
        setStorage() {
            const { name, params, query } = this.$route
            setStorage(
                HISTORY_KEY,
                [{
                    route: { name, params, query },
                    title: this.pageInfo.title,
                    timestamp: Date.now()
                }],
                true
            )
        },
        goRoute(item){
            if(item.link){
                window.location.href = item.link
            }else{
                this.$router.push(item.to)
            }
            this.showMenu = false
        },
        initWatch() {
            this.$watch('$route', (r, or) => {
                // 更新追踪
                if (!this.hasInited || r.meta.init) {
                    this.hasInited = true
                    // this.$initSet(this.pageInfo)
                    // initJsConfig(['updateAppMessageShareData',
                    // 'updateTimelineShareData',
                    // 'hideMenuItems',
                    // 'startRecord', // 录音开始api
                    // 'stopRecord', // 录音结束api
                    // 'onVoiceRecordEnd', // 超过一分钟自动停止api
                    // 'playVoice', // 播放录音api
                    // 'pauseVoice', // 暂停录音api
                    // 'stopVoice', // 停止播放api
                    // 'onVoicePlayEnd', // 监听语音播放完毕api
                    // 'uploadVoice',
                    // 'translateVoice'])

                } else {
                    if (!r.meta.noTrack) {
                        // this.$baseSetting(this.pageInfo)
                        setBaseInfo(this.pageInfo)
                    }
                    if (or.meta.needLoading) {
                        if (this._preloadTimer) {
                            clearInterval(this._preloadTimer)
                            this._preloadTimer = null
                        }
                    }
                }
                this.setStorage()
            }, { immediate: true })
        }
    },
    async created() {
        await this.setInfo()
        // 初始化wxconfig
        this.initWatch()
        // 页面追踪
        this.$root.$on('pageview', (params) => {
            if(params.title && !params.title.startsWith(this.$route.meta.title)){
                params.title = concatWithSymbol([this.$route.meta.title, params.title])
            }
            setBaseInfo(Object.assign({}, this.pageInfo, params))
        })
        this.$root.$on('actionView', ({ type, params }) => {
            const t = Object.assign({
                title: this.pageInfo.title,
                path: window.location.href,
                uaId: window.ca('get', 'tid'),
                cms: this.cmsStr
            }, params)
            window.cw('action', type, t)
        })
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin';
#app {
    display: flex;
    flex-direction: column;
    text-align: left;
    height: 100%;
    overflow: hidden;
    font-size: 0.65rem;
}
.sr {
    position: relative;
    flex: 1;
    overflow-y: auto;
}
</style>
<style lang="less">
@import '~@/assets/style/mixin';
.nav {
    width: 100%;
    height: @navHeight;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 1rem;
    box-shadow: 0 2px 2px #f3f3f3;
    .logo-wrapper,
    .right {
        height: 100%;
        display: flex;
        align-items: center;
    }
    .search {
        width: 0.85rem;
        margin-right: 0.4rem;
    }
    .logo {
        height: 100%;
        &:not(:first-child) {
            margin-left: @spacing;
        }
    }
    .menu {
        width: 1.25rem;
    }
}
</style>
